module.exports = __webpack_public_path__ + "img/13942.3dc71ae8.svg";